import {
  IconUser,
  IconCreditCard,
  IconBriefcase,
  IconUsers,
} from "@tabler/icons-react";
import StatCard from "./StatCard";
import styles from "./ClientActivitySummary.module.css";

export default function ActivitySummary({ stats, totalJobs }) {
  return (
    <div>
      <div className={styles.activityLabel}>Activity Summary</div>
      <div className={styles.activityGrid}>
        <StatCard
          label="Total Credits"
          value={stats?.totalCredits ?? 0}
          icon={IconUser}
          variant="navy"
        />
        <StatCard
          label="Subscriptions"
          value={stats?.isActive ? "1" : "0"}
          icon={IconCreditCard}
        />
        <StatCard
          label="Active Jobs/Gigs"
          value={totalJobs ?? 0}
          icon={IconBriefcase}
        />
      </div>
    </div>
  );
}
